import styled from "styled-components";

import { BaseCell } from "@similarweb/pro-logic-components";
import { Text } from "@similarweb/ui-components/foundations";

export const StyledBaseCell = styled(BaseCell)`
    display: flex;
    justify-content: center;
    width: 100%;
`;

export const StyledAccuracyGradeText = styled(Text)`
    display: flex;
    justify-content: center;
    align-items: center;
    border-radius: 12px;
    width: 24px;
    height: 24px;
    color: #793aaf;
    background-color: #f9efff;
    font-weight: 700;
`;
